import React, { useState } from 'react';
import { Box, Container, Paper, Tab, Tabs, Typography } from '@mui/material';
import BoltCapacityTable from './BoltCapacityTable';
import NutsTable from './NutsTable';
import WashersTable from './WashersTable';

const BoltTables = () => {
  const [tab, setTab] = useState(0);

  return (
    <Container maxWidth={false} sx={{ pb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Bolt reference tables
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Metric bolts, ISO 4032 nuts, and washer dimensions — static reference data. Not a substitute for project-specific
        verification.
      </Typography>

      <Paper elevation={2} sx={{ p: 2 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto">
            <Tab label="Bolts (capacities)" />
            <Tab label="Nuts (ISO 4032)" />
            <Tab label="Washers" />
          </Tabs>
        </Box>

        {tab === 0 && <BoltCapacityTable />}
        {tab === 1 && <NutsTable />}
        {tab === 2 && <WashersTable />}
      </Paper>
    </Container>
  );
};

export default BoltTables;
